export const SET_SETTINGS = 'SET_SETTINGS'

export const requestSetSettings = settings =>
  ({
    type: SET_SETTINGS,
    settings
  })

export const setSettings = settings =>
  dispatch => {
    dispatch(requestSetSettings(settings))
  }



// WEBPACK FOOTER //
// ./src/actions/settings.js